import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { referralSettingFormDefault } from "@factory/form/form.default";
import { ReferralSettingFormRule, ReferralSettingFormSchema } from "@factory/form/form.rule";
import { useQyCreateReferralSetting } from "@factory/query/referral-setting.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewReferralSetting() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateReferralSetting } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();
  const { getUserRole } = useUserIdentityContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New ReferralSetting is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addReferralSetting, isLoading: isCreating } =
    useQyCreateReferralSetting(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ReferralSettingFormSchema>({
    defaultValues: referralSettingFormDefault,
    resolver: zodResolver(ReferralSettingFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ReferralSettingFormSchema) => {
    const { tenant } = getUserRole();
    const updatedForm = {
      ...form,
      tenant
    } as ReferralSettingFormSchema
    const formData = mapCreateReferralSetting(updatedForm);
    addReferralSetting(formData);
  };
  const handleValidateError = (err: FieldErrors<ReferralSettingFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
